const VALIDATION_CODE_PATTERN = /^[a-z0-9_]+$/;

/** Fallback key for validation messages that are not one of our codes (e.g. zod defaults). */
export const GENERIC_VALIDATION_KEY = "rewards.validation.invalid";

/**
 * Translation key for a validation message. The rewards-core schemas and
 * validators report snake_case codes (`program_name_required`); anything else
 * (a zod default message) maps to a generic key so raw English never renders.
 */
export function validationMessageKey(message: string | undefined): string {
  if (!message) return GENERIC_VALIDATION_KEY;
  return VALIDATION_CODE_PATTERN.test(message) ? `rewards.validation.${message}` : GENERIC_VALIDATION_KEY;
}

/**
 * Parses a number input for a nullable field: an empty input clears the value
 * (`null`) instead of snapping to 0.
 */
export function parseOptionalNumber(raw: string): number | null {
  if (raw.trim() === "") return null;
  const parsed = Number(raw);
  return Number.isNaN(parsed) ? null : parsed;
}

/**
 * Parses a number input for a required field: an empty input becomes `NaN`, so
 * the schema reports it instead of silently submitting 0.
 */
export function parseRequiredNumber(raw: string): number {
  return raw.trim() === "" ? Number.NaN : Number(raw);
}

/** Renders a number for an input; `null` / `NaN` render as an empty, clearable field. */
export function numberInputValue(value: number | null | undefined): string | number {
  return value == null || Number.isNaN(value) ? "" : value;
}
